import {Injectable} from "@angular/core";
import {catchError, throwError} from "rxjs";
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {AuthService} from "@services/auth.service";
import {Observable} from "rxjs/internal/Observable";
import {Router} from "@angular/router";
import {CustomUiService} from '@services/custom-ui.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private authService: AuthService,
        private router: Router,
        private customUi: CustomUiService
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let token = this.authService.getToken();

        // ✅ Default headers
        const defaultHeaders = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };

        // ✅ If token exists, add Authorization
        if (token) {
            defaultHeaders["Authorization"] = `Bearer ${token}`;
        }

        // ✅ Clone request with headers
        const authReq = req.clone({
            setHeaders: defaultHeaders
        });

        return next.handle(authReq).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    this.customUi.showToast('Session expired. Please log in again.', 'error', 'error', 'top-end', 3000);
                    this.authService.logout();
                    this.router.navigate(['/login']);
                }
                return throwError(() => error);
            })
        );
    }
}
